import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';

export const SpecialOrderMessage = () => (
  <div className="hddc__message">
    <Image
      className="hddc__message-image"
      src="https://assets.thdstatic.com/images/v1/advisory.svg"
      alt="warning"
      height="11"
      width="11"
    />
    <p>Only available through The Home Depot Design Center in San Diego, CA or Rockville, MD</p>
  </div>
);